export default ((am2) => {

	const { fn: { loadJs } = {} } = am2;

	return () => {
		const tabs = document.querySelectorAll('.wp-block-am2-floor-views');
		if (tabs.length) {
			// Tabs - make sure 1st is selected
			// Uggly, is not that HARD to leave the prefered tab selected in backend
			// It makes sense to have the option to open any tab by default
			[...tabs].map(item => {
				const nav = item.querySelector('.am2-floor-views__nav-item--active');
				const panel = item.querySelector('.am2-floor-views__item--active');
				if (nav) nav.classList.remove('am2-floor-views__nav-item--active');
				if (panel) panel.classList.remove('am2-floor-views__item--active');
				item.querySelector('.am2-floor-views__nav-item').classList.add('am2-floor-views__nav-item--active');
				item.querySelector('.am2-floor-views__item').classList.add('am2-floor-views__item--active');
			});

			// Init tabs with custom classes
			// This approach should be automated using data attributes instead
			// And classes should be picked up and created automatically
			// I will update this script in the future
			am2.Tabs.init(tabs, {
				classes: {
					currentNav: 'am2-floor-views__nav-item--active',
					currentPanel: 'am2-floor-views__item--active'
				},
				selectors: {
					trigger: '.am2-floor-views__nav-item__link',
					content: '.am2-floor-views__item',
					current: '.am2-floor-views__item--active',
				},
				events: {
					tabOpen: (el) => {
						const figure = el.find('figure.am2-image--main');
						if (figure.data('plugin_paver') === undefined) {
							figure.paver();
						}
					}
				}
			});

			const success = () => {
				const images = document.querySelectorAll('.am2-floor-views__item figure.am2-image--main');
				[...images].map(i => {
					// Update full URL source
					const image = i.querySelector('img');
					image.setAttribute('src', image.getAttribute('src').replace('-scaled', ''));
					// Add Compass Icon
					const icon = document.createElement('div');
					icon.className = 'paver__compass';
					icon.innerHTML = `<?xml version="1.0" encoding="iso-8859-1"?>
					<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
					<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
						viewBox="0 0 477.867 477.867" style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve">
						<path fill="white" d="M238.933,0C106.974,0,0,106.974,0,238.933s106.974,238.933,238.933,238.933s238.933-106.974,238.933-238.933
							C477.726,107.033,370.834,0.141,238.933,0z M238.933,443.733c-113.108,0-204.8-91.692-204.8-204.8s91.692-204.8,204.8-204.8
							s204.8,91.692,204.8,204.8C443.611,351.991,351.991,443.611,238.933,443.733z"/>
						<path fill="white" d="M355.138,115.063c-4.793-2.388-10.428-2.388-15.221,0h0L195.106,187.46c-3.31,1.653-5.993,4.336-7.646,7.646
							l-72.397,144.811c-4.203,8.437-0.771,18.683,7.665,22.886c4.793,2.388,10.428,2.388,15.221,0l144.811-72.397
							c3.31-1.653,5.993-4.336,7.646-7.646l72.397-144.811C367.006,129.513,363.575,119.267,355.138,115.063z M168.499,309.367
							l38.912-77.824l38.912,38.912L168.499,309.367z M270.455,246.323l-38.912-38.912l77.824-38.912L270.455,246.323z"/>
					 </svg>`;
					i.appendChild(icon);
				});
				// Load Panorama for the 1st element on load
				$('.am2-floor-views__item:first-child figure.am2-image--main').paver();
			};

			loadJs([
				'https://cdnjs.cloudflare.com/ajax/libs/paver/1.3.4/js/jquery.paver.min.js',
				'https://cdnjs.cloudflare.com/ajax/libs/paver/1.3.4/css/paver.min.css',
				'https://cdnjs.cloudflare.com/ajax/libs/jquery-throttle-debounce/1.1/jquery.ba-throttle-debounce.min.js'
			], {
				async: false,
				success
			});
		}
	};
}).apply(this, [window.am2 || {}])();